import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

// Thunk to book an appointment
export const book_appointment_client = createAsyncThunk(
  "appointmentsClient/book_appointment_client",
  async (appointmentData, { rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await api.post(
        "/book-appointment-client",
        appointmentData,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Unexpected error occurred"
      );
    }
  }
);

// Existing get_appointment_byid Thunk
export const get_appointment_by_doctor_id = createAsyncThunk(
  "appointmentsClient/get_appointment_by_doctor_id",
  async (doctorId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(
        `/client/get-appointment-by-doctor-id/${doctorId}`,
        {
          withCredentials: true,
        }
      );

      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const get_appointment_by_client_id = createAsyncThunk(
  "appointmentsClient/get_appointment_by_client_id",
  async (userId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(
        `/client/get-appointment-by-client-id/${userId}`,
        {
          withCredentials: true,
        }
      );

      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const delete_appointment = createAsyncThunk(
  "appointments/delete_appointment",
  async (appointmentId, { rejectWithValue }) => {
    try {
      const response = await api.delete(
        `/delete-appointment/${appointmentId}`,
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to delete appointment."
      );
    }
  }
);

export const appointmentReducer = createSlice({
  name: "appointmentsClient",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: false,
    doctorAppt: [],
    clientAppt: [],
    doctorTotalAppointments: 0,
    clientTotalAppointments: 0,
    clientPendingAppt: 0,
    clientAcceptedAppt: 0,
    clientDoneAppt: 0,
    clientRefusedAppt: 0,
  },

  reducers: {
    messageClear: (state) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
  extraReducers: {
    [book_appointment_client.pending]: (state) => {
      state.loader = true;
      state.errorMessage = "";
      state.successMessage = "";
    },
    [book_appointment_client.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
    },
    [book_appointment_client.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload.message || "Failed to book appointment.";
    },
    [get_appointment_by_doctor_id.fulfilled]: (state, { payload }) => {
      state.doctorAppt = payload.doctorAppt;
      state.doctorTotalAppointments = payload.doctorTotalAppointments;
    },
    [get_appointment_by_client_id.fulfilled]: (state, { payload }) => {
      state.clientTotalAppointments = payload.clientTotalAppointments;
      state.clientAppt = payload.clientAppt;
      state.clientPendingAppt = payload.clientPendingAppt;
      state.clientAcceptedAppt = payload.clientAcceptedAppt;
      state.clientDoneAppt = payload.clientDoneAppt;
      state.clientRefusedAppt = payload.clientRefusedAppt;
    },
  },
});

export const { messageClear } = appointmentReducer.actions;
export default appointmentReducer.reducer;
